export const COMISSIONAMENTOS = () => `/comissionamentos`;
export const COMISSIONAMENTOS_REGRAS = () => `/comissionamentos/regras`;
export const COMISSIONAMENTOS_HOME = () => `/comissionamentos/home`;
export const COMISSIONAMENTOS_LISTAS = () => `/comissionamentos/listas`;
export const COMISSIONAMENTOS_PAGAMENTOS = () => `/comissionamentos/pagamentos`;
export const COMISSIONAMENTOS_CONTRATOS = () => `/comissionamentos/contratos`;
export const COMISSIONAMENTOS_MOVIMENTACOES = () => `/comissionamentos/movimentacoes-retroativas`;